import { TrendingUp, Users, Crown } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const ArtistCard = ({ artist, onFollow, isTopFan }) => {
  const navigate = useNavigate();

  const scoreColor = artist.current_score >= 1.5
    ? "text-emerald-400"
    : artist.current_score >= 1.0
    ? "text-[#FF6B35]"
    : "text-red-400";

  return (
    <div
      className="bg-card border border-border rounded-3xl p-5 hover:border-[#FF6B35]/30 transition-colors duration-300 cursor-pointer group shadow-sm"
      onClick={() => navigate(`/artist/${artist.id}`)}
      data-testid={`artist-card-${artist.id}`}
    >
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#FF6B35] to-[#7000FF] flex items-center justify-center shrink-0 group-hover:shadow-lg group-hover:shadow-[#FF6B35]/20 transition-shadow duration-300 relative">
          {artist.avatar_url ? (
            <img src={artist.avatar_url} alt="" className="w-full h-full rounded-2xl object-cover" />
          ) : (
            <span className="text-white font-heading font-bold text-xl">
              {(artist.name || "?")[0].toUpperCase()}
            </span>
          )}
          {isTopFan && (
            <div className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-yellow-400 flex items-center justify-center border-2 border-card shadow-sm" data-testid={`top-fan-badge-${artist.id}`}>
              <Crown className="w-3 h-3 text-yellow-800" />
            </div>
          )}
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <h3 className="font-heading font-bold text-card-foreground truncate group-hover:text-[#FF6B35] transition-colors duration-200 flex items-center gap-1.5">
            {artist.name}
            {artist.verified && (
              <svg className="w-4 h-4 text-[#7000FF] shrink-0" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
            )}
          </h3>
          <div className="flex items-center gap-3 mt-1">
            <span className="flex items-center gap-1 text-xs text-muted-foreground">
              <Users className="w-3 h-3" />
              {artist.fan_count} fans
            </span>
            <span className={`flex items-center gap-1 text-xs font-mono-credits ${scoreColor}`}>
              <TrendingUp className="w-3 h-3" />
              {artist.current_score?.toFixed(2)}
            </span>
          </div>
          {artist.genres?.length > 0 && (
            <div className="flex gap-1 mt-2 flex-wrap">
              {artist.genres.slice(0, 3).map((g) => (
                <span
                  key={g}
                  className="text-[10px] px-2 py-0.5 rounded-full bg-muted text-card-foreground/80 border border-border"
                >
                  {g}
                </span>
              ))}
            </div>
          )}
        </div>

        {/* Follow + Score */}
        <div className="flex flex-col items-end gap-2 shrink-0">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onFollow?.(artist.id);
            }}
            className={`text-xs font-semibold px-4 py-1.5 rounded-full transition-all duration-200 ${
              artist.is_following
                ? "bg-muted text-muted-foreground border border-border hover:bg-border"
                : "bg-[#FF6B35] text-white shadow-[0_0_15px_rgba(255,107,53,0.3)] hover:shadow-[0_0_25px_rgba(255,107,53,0.5)] hover:scale-105 active:scale-95"
            }`}
            data-testid={`follow-btn-${artist.id}`}
          >
            {artist.is_following ? "Suivi" : "Suivre"}
          </button>
        </div>
      </div>
    </div>
  );
};
